import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef } from "react";
import { PaneHeader, SeriesPicker } from "../../../lib/core";
export function PaneHeaderWithPickerWrapper({ pane, onToggleVisible, onRemove, onQuickAddSeries, onQuickRemoveSeries, style, children, }) {
    const [isOpen, setIsOpen] = useState(false);
    const addRef = useRef(null);
    return (_jsxs(_Fragment, { children: [_jsx(PaneHeader, { pane: pane, onToggleVisible: onToggleVisible, onRemove: onRemove, onAddSeries: () => setIsOpen(true), addButtonRef: addRef, style: style, children: children }), isOpen && onQuickAddSeries && (_jsx(SeriesPicker, { pane: pane, onAddSeries: (series) => {
                    onQuickAddSeries(series);
                    setIsOpen(false);
                }, onRemoveSeries: onQuickRemoveSeries ?? (() => { }), anchorRef: addRef, onClose: () => setIsOpen(false) }))] }));
}
